import React from 'react'

interface EventIconProps {
  /** 事件类型，如 token_recharge、exchange 等 */
  event: string
  /** 图标尺寸 class，默认 w-5 h-5 */
  iconClassName?: string
  /** 容器尺寸 class，默认 w-11 h-11 */
  className?: string
}

/**
 * 流水事件图标组件
 * 根据事件类型渲染对应的 /icon/{event}.svg 图标
 */
const EventIcon: React.FC<EventIconProps> = ({
  event,
  iconClassName = 'w-5 h-5',
  className = 'w-11 h-11',
}) => {
  return (
    <div className={`rounded-full bg-[#F2F4F7] flex items-center justify-center flex-shrink-0 ${className}`}>
      <img src={`/icon/${event}.svg`} alt="" className={iconClassName} />
    </div>
  )
}

export default React.memo(EventIcon)

